import React, { useState } from 'react';
import { LinkButton } from '../../../CommonComponents/Button';
import Tooltip from '../../../CommonComponents/Tooltip';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { ListItem } from '../../../CommonComponents/OPL/List/ListItem';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
  MenuTriggerItem,
} from '../../../CommonComponents/OPL/Menu/Menu';
import { ContactModal } from './components/ContactModal/ContactModal';
import { DemoModal } from './components/DemoModal/DemoModal';
import { HelpModal } from './components/HelpModal/HelpModal';
import { HelpMenu } from './components/HelpMenu/HelpMenu';
import { useFeatureFlag } from '../../../_hooks/useFeatureFlag';
import { Feature } from '../../../CommonSelectors/CommonArea.types';
import { Tooltip as OPLTooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';

const defaultMedia = 'text';

enum ModalStep {
  Help = 'Help',
  Demo = 'Demo',
  Contact = 'Contact',
}

export const Help = () => {
  const [modalStep, setModalStep] = useState<ModalStep | null>(null);
  const isGliaMenu = useFeatureFlag(Feature.GliaMenu);

  return (
    <>
      {isGliaMenu ? (
        <li>
          <OPLTooltip content="Help and support menu" placement="bottom">
            <Menu>
              <MenuTrigger>
                <Box display="flex" height="100%" alignItems="center">
                  <IconButton
                    aria-label="Menu"
                    icon="fas fa-comments"
                    variant="link"
                    size="large"
                  />
                </Box>
              </MenuTrigger>

              <MenuContent>
                <Menu>
                  <MenuTriggerItem>
                    <ListItem>
                      <Icon className="far fa-books" color="neutral.700" mr="8" />
                      Help Library
                    </ListItem>
                  </MenuTriggerItem>

                  <MenuContent sideOffset={0} width={310}>
                    <HelpMenu
                      onDemo={() => setModalStep(ModalStep.Demo)}
                      onContact={() => setModalStep(ModalStep.Contact)}
                    />
                  </MenuContent>
                </Menu>

                {ADV.data.user.ShowGlia && (
                  <MenuItem>
                    <ListItem
                      onClick={() => {
                        if (!window.saleMove) {
                          return;
                        }

                        window.saleMove
                          .getQueues()
                          .then(queues => {
                            if (queues && queues.length > 0) {
                              const findQueue = queues.find(
                                queue => queue.id === ADV.settings.glia.queueId,
                              );

                              const availableMedia = findQueue.state?.medias || [defaultMedia];

                              const preferredMedia =
                                ['text', 'audio', 'video', 'phone'].find(media =>
                                  availableMedia.includes(media),
                                ) || defaultMedia;

                              window.saleMove.queueForEngagement(preferredMedia, {
                                queueId: findQueue.id,
                              });
                            } else {
                              window.saleMove.queueForEngagement(defaultMedia);
                            }
                          })
                          .catch(error => {
                            console.error('Failed to queue for engagement:', error);

                            if (window.saleMove.visitorApp?.showMediaSelection) {
                              window.saleMove.visitorApp.showMediaSelection();
                            }
                          });
                      }}
                    >
                      <Icon className="fas fa-comments" color="neutral.700" mr="8" />
                      Customer Support
                    </ListItem>
                  </MenuItem>
                )}
              </MenuContent>
            </Menu>
          </OPLTooltip>
        </li>
      ) : (
        <li className="button-item">
          <div className="button-item__container">
            <Tooltip tag="div" tooltipchildren="Help" orientation="bottom">
              <LinkButton
                prependIcon="fa fa-question-circle"
                size="big"
                className="right-buttons__button"
                aria-label="help"
                onClick={() => setModalStep(ModalStep.Help)}
                style={{ marginBottom: 4 }}
              />
            </Tooltip>
          </div>
        </li>
      )}

      {modalStep === ModalStep.Help && (
        <HelpModal
          onClose={() => setModalStep(null)}
          onDemo={() => setModalStep(ModalStep.Demo)}
          onContact={() => setModalStep(ModalStep.Contact)}
        />
      )}

      {modalStep === ModalStep.Demo && (
        <DemoModal onClose={() => setModalStep(null)} onBack={() => setModalStep(ModalStep.Help)} />
      )}

      {modalStep === ModalStep.Contact && (
        <ContactModal
          onClose={() => setModalStep(null)}
          onBack={() => setModalStep(ModalStep.Help)}
        />
      )}
    </>
  );
};
